module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_USDAlogo.b9b3fde1.gif";